module.exports = __webpack_public_path__ + "static/media/turkdili.8d8a36d0.jpg";